var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTrendingSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_fluent_arrow_trending_24_regular") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD0D-System-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_arrow_trending_24_regular",
    fill: "#212121",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.748109,5.5 L21.3019242,5.50051747 L21.4021456,5.51444244 L21.4021456,5.51444244 L21.5009898,5.54204665 L21.5009898,5.54204665 L21.5612467,5.5675979 L21.5612467,5.5675979 C21.6405078,5.60246184 21.7147377,5.6531499 21.779948,5.71835585 L21.8206583,5.76240015 L21.8206583,5.76240015 L21.8642064,5.81878079 L21.8642064,5.81878079 L21.9183676,5.90890372 L21.9183676,5.90890372 L21.9570435,5.99922163 L21.9570435,5.99922163 L21.9762122,6.06329705 L21.9762122,6.06329705 L21.9898018,6.12730035 L21.9898018,6.12730035 L21.9991454,6.22150278 L21.9991454,6.22150278 L21.9996358,13.7538905 C21.9996358,14.168104 21.6638494,14.5038905 21.2496358,14.5038905 C20.86994,14.5038905 20.5561448,14.2217366 20.5064824,13.855661 L20.4996358,13.7538905 L20.4991881,8.059 L12.7803479,15.7792573 C12.5140876,16.0455355 12.0974196,16.069753 11.8038008,15.8519026 L11.7196801,15.7792854 L8.74919829,12.8089181 L3.27951815,18.2785982 C2.98662493,18.5714914 2.5117512,18.5714914 2.21885798,18.2785982 C1.95259142,18.0123316 1.92838537,17.5956679 2.14623983,17.3020565 L2.21885798,17.217938 L8.21885798,11.217938 C8.48512091,10.9516751 8.90177775,10.9274656 9.19538927,11.1453121 L9.27950793,11.2179278 L12.2499719,14.1882773 L19.4371881,7 L13.748109,7 C13.3684132,7 13.054618,6.71784612 13.0049556,6.35177056 L12.998109,6.25 C12.998109,5.87030423 13.2802629,5.55650904 13.6463384,5.50684662 L13.748109,5.5 Z",
    id: "\\uD83C\\uDFA8-Color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendingSvgrepoCom);
export default __webpack_public_path__ + "static/media/arrow-trending-svgrepo-com.446418565375ff3856fd6db37cdbcc6a.svg";
export { ForwardRef as ReactComponent };